export default {
  version: 'Version {version}',
  empty: 'Hier erscheinen die Neuerungen neuer Qmulus-Versionen.',
  releaseNotes: 'Alle Änderungen in Version {version}',
  versions: 'Versionen',
};
